const messages = {
    buttons: {
        productBrochures: "Odkryj",
    },
    index: {
        title: "INFORMACJE O PRODUKCIE",
        description: "Pobierz tutaj najnowsze broszury i ulotki naszych opon Bridgestone i Firestone.",
        categories: {
            productBrochures: {
                title: "Broszury produktowe",
                description: "Broszury serii opon Bridgestone i Firestone",
            },
            bDrive: {
              title: "Zdjęcia produktów",
              description: "Aktualne zdjęcia można pobrać z naszego portalu B-DRIVE.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

